module.exports = __webpack_public_path__ + "static/media/icone-e-obrigado.694001ff.png";